import {http_client} from "@/plugins/http_client";

const url = '/api/v1/rutas'
const getPaths = async (params = {}) => await http_client(url, params, 'get')
const storePath = async (body) => await http_client(url, body, 'post')
const getPath = async (idPath) => await http_client(`${url}/${idPath}`)
const updatePath = async (idPath, body) => await http_client(`${url}/${idPath}`, body, 'put')
const deletePath = async (idPath) => await http_client(`${url}/${idPath}`, {}, 'delete')
const getAuthorizedPaths=async()=>await http_client(`${url}/get-rutas`)
const rutasClasificador=async(params = {})=>await http_client(`${url}/clasificador`, params, 'get')

export default {
    getPaths,
    storePath,
    getPath,
    updatePath,
    deletePath,
    getAuthorizedPaths,
    rutasClasificador
}